import React from 'react'
import EmptySearch from "assests/emptySearch.svg";
import CustomTypography from 'components/Fileds/CustomTypography';
import { Box, useTheme } from '@mui/material';
// import "./style.css";

const NoSearchFound = ({title, subtitle, img, height, width}) => {
    const theme = useTheme();
  return (
    <Box className='d-flex align-items-center justify-content-center empty-card-contianer' sx={{flexDirection:'column'}}>
        <img
            src={img ? img : EmptySearch}
            alt='empty'
            className='empty-image'
            style={{height: height ? height : '300px', width: width ? width : '300px', marginBottom:'20px'}}
        />
        <Box className='d-flex align-items-center justify-content-center empty-card-text' sx={{flexDirection:'column'}}>
            <CustomTypography
                label={title}
                sx={{fontSize:'24px', fontWeight: 700, color:theme.palette.lightgrey.main, mb: 1}}
            />
            <CustomTypography
                label={subtitle}
                sx={{fontSize:'14px', fontWeight: 400, color:theme.palette.lightgrey.main, mb: 1}}
            />
        </Box>
    </Box>
  )
}

export default NoSearchFound
